// strokeInput — `stroke.start.input` / `stroke.start.pressure` (入力手段と筆圧オンの計測、
// pen-usage-analytics-2026-08-18.md §12) を作る pure helper。
//
// packages/web の vitest は node env (DOM なし) なので、PointerEvent を触らずに
// 判定だけここへ切り出して単体テストする (penOnlyMode.ts と同じ流儀)。

import type { PenPressureSettings } from './penPressure.js';

/** wire の `stroke.start.input` が取る値 (protocol `strokeStartSchema`)。 */
export type StrokeInputKind = 'pen' | 'touch' | 'mouse';

/**
 * `PointerEvent.pointerType` → `stroke.start.input`。
 * 3 値以外 (`''` / 将来の新規値) は `undefined` (= field を送らない)。
 */
export const strokeInputFromPointerType = (raw: string): StrokeInputKind | undefined => {
  if (raw === 'pen' || raw === 'touch' || raw === 'mouse') return raw;
  return undefined;
};

/** そのストロークに適用した筆圧設定が、太さ・濃さのどちらかでオンか。 */
export const isPressureOn = (settings: PenPressureSettings): boolean =>
  settings.widthEnabled || settings.alphaEnabled;
